import Image from '../../services/image'
import * as types from '../mutationTypes'

let state = {
  error: null,
  status: '',
  id: null,
  images: [],
  imagesByTask: [],
  headers: [
    { text: 'ID', value: 'id' },
    { text: 'Task ID', value: 'workOrderTaskId' },
    { text: 'Uploaded By', value: 'user' },
    { text: 'Approved By', value: 'user2' },
    { text: 'Document Type', value: 'documentType' },
    { text: 'URL', value: 'url' },
    { text: 'File Name', value: 'fileName' },
    { text: 'Pole Id', value: 'poleId' },
    { text: 'Description', value: 'description' },
    { text: 'Actions', value: 'action', sortable: false }
  ]
}

const getters = {
  selectList (state) {
    return state.images.map(image => {
      return { text: image.fileName, value: image.id }
    })
  },
  id (state) {
    return state.id
  },
  images (state) {
    return state.images
  },
  headers () {
    return state.headers
  },
  error (state) {
    return state.error
  },
  imagesByTask (state) {
    return state.imagesByTask
  },
  status (state) {
    return state.status
  }
}

const actions = {
  async loadImages ({ commit, dispatch }, limit, offset) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      const res = await Image.get(limit, offset)
      if (res) {
        commit(types.REQUEST_GET_IMAGES_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_IMAGES_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadImagesByTask ({ commit, dispatch }, { taskId, size }) {
    size = size || 'original'
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })

    try {
      const res = await Image.getByTask(taskId, size)

      if (res) {
        commit(types.REQUEST_GET_IMAGE_TASK_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_IMAGE_TASK_ERROR, 'Error getting images')
    }

    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async uploadCreateImage ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Image.uploadCreate(data)
      if (res) {
        commit(types.REQUEST_UPLOAD_IMAGE_SUCCESS, res.data)
        return res.data
      }
    } catch (err) {
      commit(types.REQUEST_UPLOAD_IMAGE_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async updateImage ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Image.update(data)
      if (res) {
        commit(types.REQUEST_UPDATE_IMAGE_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_UPDATE_IMAGE_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async deleteImage ({ commit }, data) {
    try {
      let res = await Image.deleteImage(data)
      if (res) {
        commit(types.REQUEST_DELETE_IMAGE_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_DELETE_IMAGE_ERROR, err)
    }
  },
  async getImageLink ({ commit }, data) {
    try {
      let res = await Image.getImage(data)
      if (res) {
        let win = window.open(res.data, '_blank')
        win.focus()
        commit(types.REQUEST_GET_IMAGE_SUCCESS)
      }
    } catch (err) {
      commit(types.REQUEST_GET_IMAGE_ERROR, err)
    }
  },
  clearErrors ({ commit }) {
    commit(types.CLEAR_ERROR_IMAGE)
  },
  clearImageTasks ({ commit }) {
    commit(types.CLEAR_IMAGE_TASK)
  }
}

const mutations = {
  [types.REQUEST_GET_IMAGES_SUCCESS] (state, data) {
    state.images = data
  },
  [types.REQUEST_GET_IMAGES_ERROR] (state, message) {
    state.error = message
    state.images = []
  },
  [types.REQUEST_GET_IMAGE_SUCCESS] (state) {
    state.error = null
  },
  [types.REQUEST_GET_IMAGE_ERROR] (state, message) {
    state.error = message
  },
  [types.REQUEST_GET_IMAGE_TASK_SUCCESS] (state, data) {
    state.errorDoc = null
    state.imagesByTask = data
  },
  [types.REQUEST_GET_IMAGE_TASK_ERROR] (state, message) {
    state.error = message
    state.imagesByTask = []
  },
  [types.REQUEST_UPLOAD_IMAGE_SUCCESS] (state, data) {
    state.error = null
  },
  [types.REQUEST_UPLOAD_IMAGE_ERROR] (state, message) {
    state.errorDoc = message
  },
  [types.REQUEST_DELETE_IMAGE_SUCCESS] (state) {
    state.error = null
  },
  [types.REQUEST_DELETE_IMAGE_ERROR] (state, message) {
    state.error = message
  },
  [types.REQUEST_UPDATE_IMAGE_SUCCESS] (state) {
    state.error = null
    state.status = 'Saved'
  },
  [types.REQUEST_UPDATE_IMAGE_ERROR] (state, message) {
    state.error = message
    state.status = 'Error'
  },
  [types.CLEAR_ERROR_IMAGE] (state) {
    state.error = null
  },
  [types.CLEAR_IMAGE_TASK] (state) {
    state.imagesByTask = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
